<dx-responsive-box labelLocation="top" id="H2ForecastReportFilters" singleColumnScreen="xs sm md">
    <dxi-row [ratio]="1"></dxi-row>
    <dxi-row [ratio]="1"></dxi-row>
    <dxi-row [ratio]="1"></dxi-row>
    <dxi-col [ratio]="1"></dxi-col>
    <dxi-col [ratio]="1"></dxi-col>
    <dxi-col [ratio]="1"></dxi-col>
    <dxi-col [ratio]="1"></dxi-col>

    <dxi-item>
        <dxi-location [row]="0" [col]="0"></dxi-location>
        <div class="dx-field">
            <div class="dx-field-label filterlable"><span class="error">*</span> HyCO Region</div>
            <div class="dx-field-value">
                <dx-tag-box #regions [dataSource]="regionDataSource" [multiline]="false"
                    [maxFilterQueryLength]="maxFilterQueryLength" (onValueChanged)="onRegionChanged($event)"
                    [showSelectionControls]="true" displayExpr="" valueExpr="" [(value)]="selectedRegion">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Regions is required">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-tag-box>
            </div>
        </div>
    </dxi-item>
    <dxi-item>
        <dxi-location [row]="0" [col]="1"></dxi-location>
        <div class="dx-field">
            <div class="dx-field-label filterlable"><span class="error">*</span> Country</div>
            <div class="dx-field-value">
                <dx-tag-box [items]="countryDataSource" [maxFilterQueryLength]="maxFilterQueryLength"
                    [multiline]="false" [searchEnabled]="true" (onValueChanged)="onCountryChanged($event)"
                    [(value)]="selectedCountries" [showSelectionControls]="true">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Country is required">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-tag-box>
            </div>
        </div>
    </dxi-item>
    <dxi-item>
        <dxi-location [row]="0" [col]="2"></dxi-location>
        <div class="dx-field">
            <div class="dx-field-label filterlable"><span class="error">*</span> State/Province</div>
            <div class="dx-field-value">
                <dx-tag-box [items]="provinceDataSource" [maxFilterQueryLength]="maxFilterQueryLength"
                    [multiline]="false" [searchEnabled]="true" (onValueChanged)="onProvinceChanged($event)"
                    [(value)]="selectedProvinces" [showSelectionControls]="true">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Province is required">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-tag-box>
            </div>
        </div>

    </dxi-item>
    <dxi-item>
        <dxi-location [row]="0" [col]="3"></dxi-location>
        <div class="dx-field">
            <div class="dx-field-label filterlable"><span class="error">*</span> City</div>
            <div class="dx-field-value">
                <dx-tag-box [items]="cityDataSource" [maxFilterQueryLength]="maxFilterQueryLength"
                    (onValueChanged)="onCityChanged($event)" [multiline]="false" [searchEnabled]="true"
                    [(value)]="selectedCities" [showSelectionControls]="true">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="City is required">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-tag-box>
            </div>
        </div>

    </dxi-item>
    <dxi-item>
        <dxi-location [row]="1" [col]="0"></dxi-location>
        <div class="dx-field">
            <div class="dx-field-label filterlable"><span class="error">*</span> Estimated Award Year</div>
            <div class="dx-field-value">
                <dx-tag-box [items]="estimatedAwardYearDataSource" [maxFilterQueryLength]="maxFilterQueryLength"
                    [multiline]="false" [(value)]="selectEdestimatedAwardYear" [showSelectionControls]="true">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Estimated Award Year is required">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-tag-box>
            </div>
        </div>

    </dxi-item>
    <dxi-item>
        <dxi-location [row]="1" [col]="1"></dxi-location>
        <div class="dx-field">
            <div class="dx-field-label filterlable"><span class="error">*</span> Forecast Driver</div>
            <div class="dx-field-value">
                <dx-tag-box [items]="forecastDriverDataSource" [maxFilterQueryLength]="maxFilterQueryLength"
                    [multiline]="false" [(value)]="selectForecastDriver" [showSelectionControls]="true">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Forecast Driver is required">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-tag-box>
            </div>
        </div>

    </dxi-item>
    <dxi-item>
        <dxi-location [row]="1" [col]="2"></dxi-location>
        <div class="dx-field">
            <div class="dx-field-label filterlable"><span class="error">*</span> Business Model</div>
            <div class="dx-field-value">
                <dx-tag-box [items]="businessModelDataSource" [maxFilterQueryLength]="maxFilterQueryLength"
                    [multiline]="false" [(value)]="selectBusinessModel" [showSelectionControls]="true">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="Business Model is required">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-tag-box>
            </div>
        </div>
    </dxi-item>
    <dxi-item *ngIf="showAdditionalDataSwitch; else elseblock">
        <dxi-location [row]="1" [col]="3"></dxi-location>
        <div class="dx-field">
            <div class="dx-field-label filterlable"><span class="error">*</span> Include all data</div>
            <div class="dx-field-value" style="width:10%">
                <dx-switch [(value)]="includeAdditionalData">
                </dx-switch>
            </div>
        </div>
    </dxi-item>
    <ng-template #elseblock>
        <dxi-item *ngIf="showAdditionalDataSwitch; else elseblock">
            <dxi-location [row]="1" [col]="3"></dxi-location>
            <div class="dx-field">
                <div class="dx-field-label filterlable"></div>
                <div class="dx-field-value">
                </div>
            </div>
        </dxi-item>
    </ng-template>
    <dxi-item>
        <dxi-location [row]="2" [col]="0" [colspan]="4"></dxi-location>
        <div class="btndiv">
            <dx-button class="ap-blue-btn" type="default" (onClick)="getReports()" text="View Reports">
            </dx-button>
        </div>
    </dxi-item>
</dx-responsive-box>